import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {HomeComponent} from './home/home.component';
import {AuthorComponent} from './author/author.component';
import {ContactComponent} from './contact/contact.component';
import {BlogComponent} from './blog/blog.component';
import {BlogDetailsComponent} from './blog/blog-details/blog-details.component';
import {MediaComponent} from './media/media.component';
import {BooksComponent} from './books/books.component';

const routes: Routes = [
    {path: '', component: HomeComponent},
    {path: 'author', component: AuthorComponent},
    {path: 'contact', component: ContactComponent},
    {path: 'blog', component: BlogComponent},
    //{path: 'blog/page/:page', component: BlogComponent},
    {path: 'blog/category/:id', component: BlogComponent},
    //{path: 'blog/category/:id/page/:page', component: BlogComponent},
    {path: 'blog/search/:keywords', component: BlogComponent},
    //{path: 'blog/search/:keywords/page/:page', component: BlogComponent},
    {path: 'blog/details/:id', component: BlogDetailsComponent},
    {path: 'media', component: MediaComponent},
    {path: 'books', component: BooksComponent},

    /**
     * All routes which doesn't exist will be redirected to root page.
     */
    {path: '**', redirectTo: ''}
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes),
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}


// WEBPACK FOOTER //
// /home3/usalinks/public_html/ally-book-source/src/app/app-routing.module.ts